import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const WhatIsNewInBetaImage = props => (
    <SvgIcon {...props}>
        <path
            d="M11.255.349c.055.03.1.075.13.13l1.76 3.256a.323.323 0 00.42.14l.02-.01L16 2.532V14.38c0 .892-.723 1.615-1.615 1.615H3.51l.378-.99a.323.323 0 00-.169-.409l-.022-.009L.213 13.32a.323.323 0 01-.081-.564l2.982-2.192a.323.323 0 00.08-.435l-.014-.021-2.241-2.94a.323.323 0 01.236-.518l3.703-.24a.323.323 0 00.302-.324V6.06L4.89 2.38a.323.323 0 01.478-.308l3.249 1.793c.15.083.338.033.429-.11l.011-.02L10.818.48a.323.323 0 01.437-.131zm-.109 13.456a.73.73 0 00-.502.204.653.653 0 00-.148.222.712.712 0 00-.054.273c0 .099.018.19.054.276a.658.658 0 00.372.365.724.724 0 00.551 0 .697.697 0 00.375-.365.681.681 0 00.056-.276.686.686 0 00-.206-.495.73.73 0 00-.498-.204zm.228-5.365h-.428a.323.323 0 00-.323.323v2.325c0 .28.014.556.042.826l.02.189.049.388c.02.161.158.282.32.282h.212c.162 0 .299-.12.32-.282l.03-.231.036-.318.003-.028c.028-.27.042-.546.042-.826V8.763a.323.323 0 00-.323-.323z"
            stroke="none"
            fillRule="evenodd"
        />
    </SvgIcon>
);

export default WhatIsNewInBetaImage;
